import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get } from 'lodash'
import { Grid, Typography, makeStyles } from '@material-ui/core'
import { FormikInputField } from 'components/form/InputField'
import { FormikMultiSelectDropdownField, FormikDropdownField } from 'components/form/Dropdown'
import { Separator } from 'components/layout/Separator'
import { adminMealtimes, adminDaysOfWeek, adminFeedingFrequencies } from 'admin/actions/admin_dropdown_options'

const useStyles = makeStyles((theme) => ({
  fieldDescription: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.54)',
    marginTop: -4,
    marginBottom: 4
  }
}))

export default function BeneficiaryVettingFeedingFields({ formik_props, fieldsDisabled = false }) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const company = get(formik_props.values, 'company', {})

  const mealsProvidedOptions = useSelector(() => adminMealtimes.getAsOptions())
  const daysOfWeekOptions = useSelector(() => adminDaysOfWeek.getAsOptions())
  const feedingFrequencyOptions = useSelector(() => adminFeedingFrequencies.getAsOptions())

  useEffect(() => {
    dispatch(adminMealtimes.fetchListIfNeeded())
    dispatch(adminDaysOfWeek.fetchListIfNeeded())
    dispatch(adminFeedingFrequencies.fetchListIfNeeded())
  }, [dispatch])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>

        <FormikMultiSelectDropdownField
          name="company.meals_provided"
          label="Meals Provided (B/L/D)"
          options={mealsProvidedOptions || []}
          formik_props={formik_props}
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Tick all meal types provided (Breakfast, Lunch, Dinner).
        </Typography>

        <Separator height={17} />

        <FormikMultiSelectDropdownField
          name="company.days_of_week"
          label="Days of the Week"
          options={daysOfWeekOptions || []}
          formik_props={formik_props}
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Tick all days services are provided. Useful for logistics planning.
        </Typography>

        <Separator height={17} />

        <FormikInputField
          name="company.feeding_history_last_date"
          type="date"
          label="Feeding History (Last date fed by SA Harvest)"
          placeholder=""
          value={get(company, 'feeding_history_last_date')}
          formik_props={formik_props}
          InputLabelProps={{ shrink: true }}
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Record the last date the CBO received food from SA Harvest.
        </Typography>

        <Separator height={17} />

        <FormikDropdownField
          name="company.feeding_frequency"
          label="Feeding Frequency"
          options={feedingFrequencyOptions || []}
          formik_props={formik_props}
          placeholder="Select..."
          disabled={fieldsDisabled}
        />

        <Separator height={17} />

        <FormikInputField
          name="company.number_of_people_served"
          type="number"
          label="Total Number of People Served"
          placeholder="Total Number of People Served"
          value={get(company, 'number_of_people_served')}
          formik_props={formik_props}
          inputProps={{ min: 0 }}
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Enter the approximate number of people served.
        </Typography>
      </Grid>
    </Grid>
  )
}
